import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

/**
 * Legacy path from the opt-in rollout period, when the sidebar layout lived at
 * its own route beside the classic tab page. The sidebar layout is now the only
 * SuperAdmin, served from `admin.superAdmin` (/SuperAdmin), so this only keeps
 * links people shared while the toggle existed from 404-ing.
 */
export const superAdminV2: RouteRecordRaw = {
  path: 'super-admin-v2',
  redirect: (to) => ({ name: 'admin.superAdmin', query: to.query }),
  meta: {
    roles: [Roles.SuperAdmin],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
}
